import React from 'react';
import classNameBind from 'classnames/bind';
import Text from '../../../Text';
import Icon from '../../../Icon';
import Checkbox from '../../../Checkbox';
import Tooltip from '../../../Tooltip';
import styles from './ListSidebarElement.module.css';
import { StatusIcon } from '../StatusIcon';

const bindClasses = classNameBind.bind(styles);

const ListSidebarElement = ({
  data,
  onClick,
  favoriteOnClick,
  withFavorites,
  bulkSelectionMode,
  onCheckboxSelect,
}) => (
  <div
    className={bindClasses('wrapper', { active: data.isActive, bulkSelectionMode })}
    data-ppuc-id="ListSidebar.ListSidebarElement.Wrapper"
  >
    {bulkSelectionMode && (
      <div className={bindClasses('checkbox-wrapper')}>
        <Checkbox
          name={`checkbox_${data.id}`}
          id={`checkbox_${data.id}`}
          dataId={`ListSidebar.ListSidebarElement.Checkbox_${data.id}`}
          checked={data.isCheckboxSelected}
          onChange={() => {
            onCheckboxSelect(data);
          }}
        />
      </div>
    )}
    {data.status && !bulkSelectionMode && (
      <button
        type="button"
        className={bindClasses('status-icon', { active: data.isActive })}
        data-ppuc-id="ListSidebar.ListSidebarElement.StatusIcon"
        disabled={data.status.disabled}
        onClick={data.status.onClick}
      >
        <StatusIcon status={data.status} />
      </button>
    )}
    <div
      className={bindClasses('element', { active: data.isActive, 'with-status': !!data.status && !bulkSelectionMode, bulkSelectionMode })}
      onClick={() => !bulkSelectionMode && onClick(data)}
      role="button"
      tabIndex={0}
      data-ppuc-id="ListSidebar.ListSidebarElement"
    >
      <div className={bindClasses('flex-text')}>
        <Tooltip content={data.title} position="top-start" hideSpeechBubble>
          <div className={bindClasses('element-main')}>
            {data.icon && (
              <Icon
                name={data.icon}
                size="default"
                className={bindClasses('element-main-icon')}
                color={data.isActive ? 'white' : 'black'}
              />
            )}
            <Text type={data.isActive && !bulkSelectionMode ? 'strong' : 'default'} dataId="ListSidebar.ListSidebarElement.text">
              {data.title}
            </Text>
          </div>
        </Tooltip>
        {withFavorites && (
          <div
            className={bindClasses('favorite')}
            onClick={(el) => {
              if (!bulkSelectionMode) {
                el.stopPropagation();
                favoriteOnClick(data);
              }
            }}
            role="button"
            tabIndex={-1}
            data-ppuc-id="ListSidebar.ListSidebarElement.Star"
          >
            {data.isFavorite
              ? <span><Icon name="star" color="yellow" /></span>
              : (
                <React.Fragment>
                  <span className={bindClasses('favorite-not-selected', 'hovered')}>
                    <Icon name="star" color={data.isActive ? 'white' : 'light-gray'} />
                  </span>
                  <span className={bindClasses('favorite-not-selected', 'not-hovered')}>
                    <Icon name="star-empty" color={data.isActive ? 'white' : 'light-gray'} />
                  </span>
                </React.Fragment>
              )
            }
          </div>
        )}
      </div>
      {data.label && (
        <Text type="subdued" dataId="ListSidebar.ListSidebarElement.label">
          {data.label}
        </Text>
      )}
      {data.rightIcons && (
        <div className={bindClasses('right-icons')}>
          {data.rightIcons.map(icon => (
            <div key={icon.name} className={bindClasses('icon')}>
              <Tooltip {...icon.tooltip}>
                <Icon name={icon.name} color={data.isActive ? 'white' : 'black'} />
              </Tooltip>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

ListSidebarElement.defaultProps = {
  data: null,
  onClick: () => {},
  favoriteOnClick: () => {},
  onCheckboxSelect: () => {},
};

export default ListSidebarElement;
